import {
  getSEOIntentConfigForSource,
  type SEOIntent,
  type SEOReportPlanId,
} from "@/lib/seo-intents";

export interface PageReportOffer {
  intent: SEOIntent;
  planId: SEOReportPlanId;
}

/**
 * Resolve the report sold by a public page through the same source -> intent ->
 * plan projection used by generate-seo-page-plan-map.mjs. Runtime CTAs must use
 * this boundary instead of hand-picking a plan id in page code (rule 40).
 */
export function resolvePageReportOffer(sourcePath: string): PageReportOffer {
  const config = getSEOIntentConfigForSource(sourcePath);
  return { intent: config.intent, planId: config.reportPlanId };
}
